import React from 'react';

// To create a link-less message, do not pass url and urlText values.
// If passing link info, add space or punctuation at end of message, which precedes link.
export interface IImportantMessage {
    message: string;
    boxWidth: number;
    url?: string;
    urlText?: string;
}

const ImportantMessage = ({
    message,
    boxWidth,
    url,
    urlText,
}: IImportantMessage) => {
    return (
        <div
            style={{
                textAlign: 'center',
                border: '1px solid #d52b1e',
                width: boxWidth,
                margin: 'auto',
                paddingTop: '8px',
                paddingBottom: '5px',
                paddingLeft: '8px',
                paddingRight: '8px',
            }}
        >
            <span
                style={{
                    color: 'black',
                    fontWeight: 'bold',
                }}
            >
                {message}
            </span>
            <a
                style={{
                    color: '#1e9be9',
                }}
                target="_blank"
                rel="noreferrer noopener"
                href={url}
            >
                {urlText}
            </a>
        </div>
    );
};

export default ImportantMessage;
